import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function TrainingCard({ title }) {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("training");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "home/get_training_list", { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setPrograms(res.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load training programs:", error);
          setPrograms([]);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  if (!loading && programs.length === 0) return null;

  return (
    <section className="sf-section sf-section-light">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title">{title || "Explore Our Training"}</h2>
        </div>

        <div className="sf-training-tabs">
          <div
            className={"sf-tab" + (activeTab === "training" ? " active" : "")}
            onClick={() => setActiveTab("training")}
          >
            Training Jobs
          </div>
          <div
            className={"sf-tab" + (activeTab === "upcoming" ? " active" : "")}
            onClick={() => setActiveTab("upcoming")}
          >
            Upcoming Training
          </div>
        </div>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : (
          <div className="sf-training-grid">
            {programs.slice(0, 4).map((prog, idx) => (
              <div key={prog.id || idx} className="sf-training-card">
                <div className="sf-training-img">
                  <img
                    src={prog.image || "/default/default_banner.jpg"}
                    alt={prog.title}
                    onError={(e) => { e.target.src = "/default/default_banner.jpg"; }}
                  />
                </div>
                <div className="sf-training-body">
                  <div className="sf-training-title">{prog.title}</div>
                  {(prog.duration || prog.level) && (
                    <div className="sf-training-meta">
                      {prog.duration && (
                        <span>
                          <i className="fa fa-clock-o" /> {prog.duration}
                        </span>
                      )}
                      {prog.level && (
                        <span style={{ marginLeft: 10 }}>
                          <i className="fa fa-signal" /> {prog.level}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="sf-training-btns">
                    <Link to="/pages/training" className="sf-btn sf-btn-primary sf-btn-sm">
                      Learn More
                    </Link>
                    <Link to="/contact-us" className="sf-btn sf-btn-outline sf-btn-sm">
                      Enroll Now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
